import React from 'react'

export const Community = ({ setShowCommunity, searchTerm, handleSearch, filteredMembers, handleCreateDM }) => {
    return (
        <div className='right-container'>
            <div className='channel-heding'>
                <div>New Message</div>
                <div className='cursor-pointer' onClick={() => setShowCommunity(false)}>x</div>
            </div>
            <div>
                <input
                    type='text'
                    placeholder='Search members...'
                    value={searchTerm}
                    onChange={handleSearch}
                    style={{
                        width: '100%',
                        padding: '8px',
                        marginBottom: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                    }}
                />
            </div>
            <div className='messageStyle scroll-container height-600'>
                {filteredMembers.map(({ id, name }) => (
                    <div key={id} className='channel' onClick={() => handleCreateDM(id)}>
                        {name}
                    </div>
                ))}
            </div>
        </div>
    )
}
